'use client';

import type { FC, JSX } from 'react';
import React from 'react';
import type { PartialPageProps } from '@/types/cms/magnolia';
import type { ApiImage } from '../../../api/model';
import { useProductPageContext } from '@/components/productPageContext/ProductPageContext';
import ImageWrapper from '@/components/image/ImageWrapper';

const PdfCoverImage: FC<{ pageProps?: PartialPageProps; pdfCoverImage: ApiImage }> = ({
  pageProps,
  pdfCoverImage
}): JSX.Element => {
  const { printMode } = useProductPageContext();

  return (
    <>
      {' '}
      {printMode && (
        <ImageWrapper
          image={pdfCoverImage}
          className="hero__image__pdf"
          useDefaultLoader
          ignoreFadeIn
          priority
          fetchPriority="high"
          pageProps={pageProps}
        />
      )}
    </>
  );
};

export default PdfCoverImage;
